import {propType} from "./methods";
import {Animated} from "react-native";

export abstract class Model {

    protected mapJsonAndVariables: any;
    protected jsonObject: any | null;

    constructor(json: any) {
        this.jsonObject = json;
    }

    private getProp(key: string): any {
        return this[key as keyof this];
    }

    private setProp(key: string, val: any | Model) {
        this[key as keyof this] = val;
    }

    protected specifyAll(): void {
        // @ts-ignore
        this["mapJsonAndVariables"]?.forEach((item, index) => {
            this.specifyModelProp(item.variable, this.jsonObject[item.jsonKey], item.address, item.array);
        });
    }

    private specifyModelProp(key: string, val: any, address: any, isModelClassArray: boolean) {
        const prop = this.getProp(key);
        const isArray = (isModelClassArray || Array.isArray(prop));

        if(val == null) {
            if(isArray)
                this.setProp(key,[]);
            else
                this.setProp(key, null);
            return;
        }

        if (!isArray)
            this.setProp(key, spec(val));

        else this.setProp(key, val.map((item: any) => {
            return spec(item);
        }));

        function spec(val: any): propType {
            let rv = null;
            if(address != undefined) {
                rv = new address(val);
            } else rv = val;
            return rv;
        }
    }

    protected addVariableAndKey(classVariableKey: string, key: string, address: any, array: boolean): void {
        // @ts-ignore
        if (this['mapJsonAndVariables'] == null)
            // @ts-ignore
            this['mapJsonAndVariables'] = [{
                variable: classVariableKey,
                jsonKey: key,
                address: address,
                array: array
            }];
        // @ts-ignore
        else this['mapJsonAndVariables'].push({
            variable: classVariableKey,
            jsonKey: key,
            address: address,
            array: array
        });
    }
}

// TODO = LISTEN: SETUP AN ARRAY OF VARIABLE NAMES AND JSON NAMES AND IN DECORATOR
// JUST SETHESE VALUES, IN CONSTRUCTOR LATER IN CHILD, WE WILL SET THEM UP